export default __webpack_public_path__ + "static/media/IkonKiste.16e76594.svg";